import { getCurrentLocaleCode } from "@mongez/localization";
import { Link as RemixLink } from "@remix-run/react";
import { type RemixLinkProps } from "@remix-run/react/dist/components";

type LinkProps = {
  to: string;
} & RemixLinkProps;

export function Link({ to, ...props }: LinkProps) {
  const lang = getCurrentLocaleCode();

  const localizedPath = `/${lang}${to}`;

  return (
    <RemixLink
      viewTransition
      to={localizedPath}
      type="canonical"
      className="block"
      {...props}
    >
      {props.children}
    </RemixLink>
  );
}
